/* eslint-disable prefer-destructuring */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import React, { useEffect, useState } from 'react';
import {
  Typography,
  AccordionSummary,
  AccordionDetails,
  Accordion,
  Box,
  Badge
} from '@mui/material';

import {
  ExpandMore as ExpandMoreIcon,
  ErrorOutline as ErrorOutlineIcon,
  CheckCircleOutline as CheckCircleOutlineIcon
} from '@mui/icons-material';

import axios from 'axios';
import { timeSince } from '../../lib/utils';
import conf from '../../conf';

export default function Status() {
  const [expanded, setExpanded] = useState(false);
  const [browserExpanded, setBrowserExpanded] = useState(false);
  const [specExpanded, setSpecExpanded] = useState(false);
  const [finalTests, setFinalTests] = useState([]);

  const url = `${conf.E2E_API_URL}test_results`;

  const setExpanedPanel = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleBrowserExpand = panel => (event, isBrowserExpanded) => {
    setBrowserExpanded(isBrowserExpanded ? panel : false);
  };
  const handleSpecExpand = panel => (event, isSpecExpanded) => {
    setSpecExpanded(isSpecExpanded ? panel : false);
  };

  const sortNameAndNumber = title => {
    let number = '';
    let name = '';
    const numbers = '0123456789';
    for (let i = 0; i < title.length; i += 1) {
      const curChar = title[i];
      if (numbers.includes(curChar)) {
        number += curChar;
      } else if (curChar !== '-') {
        name += curChar;
      }
    }
    return [number, name];
  };

  const fetchResults = async curTest => {
    try {
      const { name } = curTest;
      const { data } = await axios.get(`${url}/${name}/results.json`);

      const results = [];

      if (data.suites[0]) {
        data.suites[0].suites.forEach(x => {
          if (x.suites) {
            results.push(x.suites[0]);
          }
          results.push(x);
        });
      }

      return results;
    } catch (err) {
      console.log(err);
      return [];
    }
  };

  const browserSort = set => {
    const chromium = { browser: 'chromium', specs: [], errorCount: 0 };
    const firefox = { browser: 'firefox', specs: [], errorCount: 0 };
    const webkit = { browser: 'webkit', specs: [], errorCount: 0 };

    set.forEach(x => {
      const curBrowser = x.browser;
      const { status } = x.tests[0].results[0];
      if (curBrowser === 'chromium') {
        if (status !== 'passed') {
          chromium.errorCount += 1;
        }
        chromium.specs.push(x);
      }
      if (curBrowser === 'webkit') {
        if (status !== 'passed') {
          webkit.errorCount += 1;
        }
        webkit.specs.push(x);
      }
      if (curBrowser === 'firefox') {
        if (status !== 'passed') {
          firefox.errorCount += 1;
        }

        firefox.specs.push(x);
      }
    });
    return [chromium, firefox, webkit];
  };

  const parseResults = newTests => {
    newTests.sort((a, b) => {
      return b.name.localeCompare(a.name);
    });

    const normalizedData = [];
    for (let i = 0; i < newTests.length; i += 1) {
      const thisTest = newTests[i];
      const { mtime, results, name } = thisTest;
      const specsArray = [];
      normalizedData[i] = {};
      normalizedData[i].mtime = mtime;
      normalizedData[i].name = name;
      normalizedData[i].errorTotal = 0;
      normalizedData[i].allSpecs = [];
      normalizedData[i].timeSinceText = timeSince(new Date(mtime));

      if (results) {
        for (let j = 0; j < results.length; j += 1) {
          const curSet = results[j];
          specsArray.push(curSet.specs);
        }
      }
      normalizedData[i].allSpecs = specsArray.flat();

      for (let z = 0; z < normalizedData[i].allSpecs.length; z += 1) {
        const nameAndNumber = sortNameAndNumber(
          normalizedData[i].allSpecs[z].title
        );

        normalizedData[i].allSpecs[z].order = nameAndNumber[0];
        normalizedData[i].allSpecs[z].title = nameAndNumber[1];

        normalizedData[i].allSpecs[z].browser =
          normalizedData[i].allSpecs[z].tests[0].projectName;
        normalizedData[i].allSpecs[z].duration =
          normalizedData[i].allSpecs[z].tests[0].results[0].duration / 1000;
        normalizedData[i].allSpecs.sort((a, b) => {
          return a.order - b.order;
        });
      }
      normalizedData[i].allSpecs = browserSort(normalizedData[i].allSpecs);
      normalizedData[i].allSpecs.forEach(x => {
        const { errorCount } = x;
        normalizedData[i].errorTotal += errorCount;
      });
    }

    return normalizedData;
  };

  const fetchAndParseResults = async () => {
    const { data } = await axios.get(url);
    const resultsToFetch = data.slice(-30);
    const tests = [];

    for (const curTest of resultsToFetch) {
      const results = await fetchResults(curTest);
      if (results.length > 0) {
        tests.push({
          ...curTest,
          results
        });
      }
    }

    const parsedResults = parseResults(tests);
    setFinalTests(parsedResults);
  };

  useEffect(() => {
    fetchAndParseResults();
  }, []);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'auto',
        paddingTop: 4
      }}
    >
      <Box
        sx={{
          width: '40%',
          maxWidth: 920,
          minWidth: 460,
          margin: 'auto'
        }}
      >
        <div>
          {finalTests.map(({ allSpecs, timeSinceText, errorTotal, name }) => (
            <Accordion
              key={name}
              expanded={expanded === name}
              onChange={setExpanedPanel(name)}
              TransitionProps={{ unmountOnExit: true }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
                style={{
                  justifyContent: 'center'
                }}
                sx={{
                  alignItems: 'center',
                  overflow: 'wrap'
                }}
              >
                <Badge color="error">
                  {errorTotal > 0 ? (
                    <ErrorOutlineIcon
                      sx={{
                        marginRight: 8
                      }}
                      color="error"
                    />
                  ) : (
                    <CheckCircleOutlineIcon
                      sx={{
                        marginRight: 8
                      }}
                      color="primary"
                    />
                  )}
                </Badge>
                {name} - {timeSinceText} ago
              </AccordionSummary>
              <AccordionDetails>
                {allSpecs
                  .filter(x => x.specs.length > 0)
                  .map((x, i) => {
                    return (
                      <Accordion
                        key={`${name}${x.browser}}`}
                        expanded={browserExpanded === x.browser + i}
                        onChange={handleBrowserExpand(x.browser + i)}
                        TransitionProps={{ unmountOnExit: true }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                          style={{
                            alignText: 'center'
                          }}
                        >
                          {x.browser}
                          {x.errorCount ? (
                            <Badge color="error">
                              <ErrorOutlineIcon
                                sx={{
                                  marginRight: 8
                                }}
                                color="error"
                                fontSize="small"
                              />
                            </Badge>
                          ) : null}
                        </AccordionSummary>
                        <AccordionDetails>
                          {x.specs.map((y, i) => {
                            return (
                              <Accordion
                                key={`${name}${y.title}`}
                                expanded={specExpanded === i + y.title}
                                onChange={handleSpecExpand(i + y.title)}
                                TransitionProps={{ unmountOnExit: true }}
                              >
                                <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel1bh-content"
                                  id="panel1bh-header"
                                  style={{
                                    alignItems: 'center'
                                  }}
                                  sx={{
                                    alignItems: 'center',
                                    overflow: 'wrap'
                                  }}
                                >
                                  {y.tests[0].results[0].status ===
                                    'passed' && (
                                    <CheckCircleOutlineIcon
                                      sx={{
                                        marginRight: 8
                                      }}
                                      fontSize="medium"
                                      color="primary"
                                    />
                                  )}
                                  {y.tests[0].results[0].status !==
                                    'passed' && (
                                    <ErrorOutlineIcon
                                      sx={{
                                        marginRight: 8
                                      }}
                                      color="error"
                                      fontSize="medium"
                                    />
                                  )}
                                  {y.title}
                                </AccordionSummary>
                                <AccordionDetails>
                                  {y.tests[0].results[0].attachments &&
                                    y.tests[0].results[0].attachments.map(
                                      attachment => {
                                        return attachment.name.includes(
                                          'video'
                                        ) ? (
                                          <Box key={`${attachment.name}`}>
                                            <Typography variant="subtitle2">
                                              Video:
                                            </Typography>
                                            <video
                                              width="100%"
                                              autoPlay
                                              muted
                                              loop
                                              controls
                                              src={`${url}/${attachment.path}`}
                                            />
                                          </Box>
                                        ) : (
                                          <Box key={`${attachment.name}`}>
                                            <Typography variant="subtitle2">
                                              Screenshot:
                                            </Typography>
                                            <Box
                                              component="img"
                                              src={`${url}${attachment.path.slice(
                                                26
                                              )}`}
                                              width="100%"
                                            />
                                          </Box>
                                        );
                                      }
                                    )}

                                  {y.tests[0].results[0].error && (
                                    <Typography variant="subtitle2">
                                      Error:{' '}
                                      {y.tests[0].results[0].error.message}
                                    </Typography>
                                  )}
                                </AccordionDetails>
                              </Accordion>
                            );
                          })}
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </Box>
    </Box>
  );
}
